import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateVendorMutationVariables = Types.Exact<{
  input: Types.CreateVendorInput;
}>;


export type CreateVendorMutation = { __typename?: 'Mutation', createVendor: { __typename?: 'VendorPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendor?: { __typename?: 'VendorStateData', description: string, erpId: string, id: string, name: string, status: Types.VendorStatus, tenantId: string, billingAddress?: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null } };

export type UpdateVendorMutationVariables = Types.Exact<{
  input: Types.UpdateVendorInput;
}>;


export type UpdateVendorMutation = { __typename?: 'Mutation', updateVendor: { __typename?: 'VendorPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendor?: { __typename?: 'VendorStateData', description: string, erpId: string, id: string, name: string, status: Types.VendorStatus, tenantId: string, billingAddress?: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null } };

export type ActivateVendorMutationVariables = Types.Exact<{
  input: Types.ActivateVendorInput;
}>;


export type ActivateVendorMutation = { __typename?: 'Mutation', activateVendor: { __typename?: 'VendorPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendor?: { __typename?: 'VendorStateData', description: string, erpId: string, id: string, name: string, status: Types.VendorStatus, tenantId: string, billingAddress?: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null } };

export type InactivateVendorMutationVariables = Types.Exact<{
  input: Types.InactivateVendorInput;
}>;


export type InactivateVendorMutation = { __typename?: 'Mutation', inactivateVendor: { __typename?: 'VendorPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendor?: { __typename?: 'VendorStateData', description: string, erpId: string, id: string, name: string, status: Types.VendorStatus, tenantId: string, billingAddress?: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null } };

export type DeleteVendorMutationVariables = Types.Exact<{
  input: Types.DeleteVendorInput;
}>;


export type DeleteVendorMutation = { __typename?: 'Mutation', deleteVendor: { __typename?: 'VendorPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendor?: { __typename?: 'VendorStateData', description: string, erpId: string, id: string, name: string, status: Types.VendorStatus, tenantId: string, billingAddress?: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null } };

export type UndeleteVendorMutationVariables = Types.Exact<{
  input: Types.UndeleteVendorInput;
}>;


export type UndeleteVendorMutation = { __typename?: 'Mutation', undeleteVendor: { __typename?: 'VendorPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendor?: { __typename?: 'VendorStateData', description: string, erpId: string, id: string, name: string, status: Types.VendorStatus, tenantId: string, billingAddress?: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null } };


export const CreateVendorDocument = new TypedDocumentString(`
    mutation CreateVendor($input: CreateVendorInput!) {
  createVendor(input: $input) {
    errors {
      code
      message
    }
    vendor {
      ...VendorState
    }
  }
}
    fragment VendorState on VendorStateData {
  billingAddress {
    ...Address
  }
  description
  erpId
  id
  name
  status
  tenantId
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const UpdateVendorDocument = new TypedDocumentString(`
    mutation UpdateVendor($input: UpdateVendorInput!) {
  updateVendor(input: $input) {
    errors {
      code
      message
    }
    vendor {
      ...VendorState
    }
  }
}
    fragment VendorState on VendorStateData {
  billingAddress {
    ...Address
  }
  description
  erpId
  id
  name
  status
  tenantId
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const ActivateVendorDocument = new TypedDocumentString(`
    mutation ActivateVendor($input: ActivateVendorInput!) {
  activateVendor(input: $input) {
    errors {
      code
      message
    }
    vendor {
      ...VendorState
    }
  }
}
    fragment VendorState on VendorStateData {
  billingAddress {
    ...Address
  }
  description
  erpId
  id
  name
  status
  tenantId
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const InactivateVendorDocument = new TypedDocumentString(`
    mutation InactivateVendor($input: InactivateVendorInput!) {
  inactivateVendor(input: $input) {
    errors {
      code
      message
    }
    vendor {
      ...VendorState
    }
  }
}
    fragment VendorState on VendorStateData {
  billingAddress {
    ...Address
  }
  description
  erpId
  id
  name
  status
  tenantId
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const DeleteVendorDocument = new TypedDocumentString(`
    mutation DeleteVendor($input: DeleteVendorInput!) {
  deleteVendor(input: $input) {
    errors {
      code
      message
    }
    vendor {
      ...VendorState
    }
  }
}
    fragment VendorState on VendorStateData {
  billingAddress {
    ...Address
  }
  description
  erpId
  id
  name
  status
  tenantId
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const UndeleteVendorDocument = new TypedDocumentString(`
    mutation UndeleteVendor($input: UndeleteVendorInput!) {
  undeleteVendor(input: $input) {
    errors {
      code
      message
    }
    vendor {
      ...VendorState
    }
  }
}
    fragment VendorState on VendorStateData {
  billingAddress {
    ...Address
  }
  description
  erpId
  id
  name
  status
  tenantId
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateVendor: build.mutation<CreateVendorMutation, CreateVendorMutationVariables>({
      query: (variables) => ({ document: CreateVendorDocument, variables })
    }),
    UpdateVendor: build.mutation<UpdateVendorMutation, UpdateVendorMutationVariables>({
      query: (variables) => ({ document: UpdateVendorDocument, variables })
    }),
    ActivateVendor: build.mutation<ActivateVendorMutation, ActivateVendorMutationVariables>({
      query: (variables) => ({ document: ActivateVendorDocument, variables })
    }),
    InactivateVendor: build.mutation<InactivateVendorMutation, InactivateVendorMutationVariables>({
      query: (variables) => ({ document: InactivateVendorDocument, variables })
    }),
    DeleteVendor: build.mutation<DeleteVendorMutation, DeleteVendorMutationVariables>({
      query: (variables) => ({ document: DeleteVendorDocument, variables })
    }),
    UndeleteVendor: build.mutation<UndeleteVendorMutation, UndeleteVendorMutationVariables>({
      query: (variables) => ({ document: UndeleteVendorDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateVendorMutation, useUpdateVendorMutation, useActivateVendorMutation, useInactivateVendorMutation, useDeleteVendorMutation, useUndeleteVendorMutation } = injectedRtkApi;
